<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <ng-container formGroupName="manualTarification">
                <div class="row">
                  <div class="col-md-12">
                    @if (isDigitalInsure) {
                      <pr-input-column label="Produit" [derrors]="derrors">
                        <mat-select formControlName="choosedProductCode">
                          @for (diProduct of diProducts; track diProduct) {
                            <mat-option [value]="diProduct.code">
                              {{ diProduct.code }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    } @else {
                      <pr-input-column label="Produit" [derrors]="derrors">
                        <input type="text" [value]="selectedProductName" disabled />
                      </pr-input-column>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      label="Coût total"
                      [derrors]="derrors"
                      [suffix]="'€'"
                    >
                      <input
                        formControlName="coutTotal"
                        type="text"
                        placeholder="2000"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      label="Coût mensuel"
                      [derrors]="derrors"
                      [suffix]="'€/mois'"
                    >
                      <input
                        formControlName="mensualite"
                        type="text"
                        placeholder="20"
                      />
                    </pr-input-column>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
